var formatRegExp = /\{(\d+)}/g;

export default function formatString(format) {
    var values = arguments;

    return format.replace(formatRegExp, function (match, index) {
        var value = values[parseInt(index, 10) + 1];

        return value;
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@telerik/kendo-intl/dist/es/common/format-string.js
// module id = 392
// module chunks = 93